// extracted by mini-css-extract-plugin
export var divider = "_o3-0";
export var systemMessage = "_o3-1";